import { createAction } from "redux-actions";
import type { History } from "history";
import {
  TOUR,
  SET_STEP_TYPE,
  SET_OPEN,
  SET_CURRENT_STEP,
  SET_PENDING_STEP,
  SET_DIALOG_READY,
} from "src/store/common";
import { setActiveDialog } from "src/store/adminHtml/actions";
import { activeDialogSelector } from "src/store/adminHtml/selector";
import {
  completeUserSetupQuestionCardConnectPlatforms,
  completeUserSetupQuestionCardManualUpload,
} from "src/apiService/modules/users";
import { TOUR_STEPS } from "src/utils/tour_steps";
import type { AppState } from "src/store/index";
import { getTourStepType } from "src/store/tour/selector";

export const setStepType = createAction(TOUR + SET_STEP_TYPE);
export const setCurrentStep = createAction(TOUR + SET_CURRENT_STEP);
export const setOpen = createAction(TOUR + SET_OPEN);
export const setPendingStep = createAction(TOUR + SET_PENDING_STEP);
export const setDialogReady = createAction(TOUR + SET_DIALOG_READY);

export function closeGlobalTour() {
  return (dispatch, getState: () => AppState) => {
    const state = getState();
    const stepType = getTourStepType(state);

    if (stepType === "connect-platforms") {
      completeUserSetupQuestionCardConnectPlatforms();
    } else if (stepType === "manual-upload") {
      completeUserSetupQuestionCardManualUpload();
    }

    // A tour that ends on a dialog step otherwise leaves that dialog standing
    // once the tour disappears — the manual upload tour finishes inside the Add
    // Transaction form. Close it so it transitions out with the tour instead of
    // stranding the user in a form they never opened. Only dialogs this tour
    // opened are closed, so an unrelated dialog is left alone.
    const activeDialog = activeDialogSelector(state);
    const openedByTour =
      !!activeDialog &&
      !!stepType &&
      !!TOUR_STEPS[stepType]?.some((step) => step.dialog === activeDialog);
    if (openedByTour) dispatch(setActiveDialog(""));

    dispatch(setCurrentStep(0));
    dispatch(setOpen(false));
    dispatch(setPendingStep(null));
    dispatch(setDialogReady(false));
  };
}

export function requestGlobalTourStep(step: number, history: History) {
  return (dispatch, getState: () => AppState) => {
    const state = getState();
    const stepType = getTourStepType(state);
    if (!stepType) return;

    const stepData = TOUR_STEPS[stepType];
    const target = stepData?.[step];
    if (!target) return;

    if (target.navigate) history.push(target.navigate);

    if (target.dialog) {
      const activeDialog = activeDialogSelector(state);
      if (target.dialog === activeDialog) {
        dispatch(setCurrentStep(step));
      } else {
        dispatch(setPendingStep(step));
        dispatch(setDialogReady(false));
        dispatch(setActiveDialog(target.dialog));
      }
    } else {
      dispatch(setActiveDialog(""));
      dispatch(setCurrentStep(step));
    }
  };
}
